import { useTranslation } from "react-i18next";

const AirTransportation = () => {
  const { t } = useTranslation();
  return (
    <main className="py-20 ">
      <div className="w-11/12 mx-auto space-y-10">
        <section>
          <h1 className=" font-semibold text-[32px] text-center pb-10 ">
            {t("airTransportation")}
          </h1>
          <h2 className="text-mainRed text-[20px] my-4 font-bold">
            {t("innovativeAndReliable")}
          </h2>
          <p className=" text-[18px]">{t("weProvideComprehensive")}</p>
        </section>
        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow"
            src="/assets/airTransport1.jpg"
            alt="air transportation 1"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow"
            src="/assets/airTransport2.jpg"
            alt="air transportation 2"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow"
            src="/assets/airTransport3.jpg"
            alt="air transportation 3"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow"
            src="/assets/airTransport4.jpg"
            alt="air transportation 4"
          />
        </section>
        <section className="bg-white shadow-md rounded-2xl p-9">
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("aLeaderInAirFreight")}
          </h2>
          <p>{t("aLeadingCompany")}</p>

          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("introductionToAirFreight")}
          </h3>
          <p>{t("airFreightIsTheIdealChoice")}</p>

          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("keyFeatures")}
          </h3>
          <p>{t("speedAndEfficiency")}</p>

          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("AirFreightProcess")}
          </h3>
          <p>{t("bookingAndRequirement")}</p>

          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("shipmentTracking")}
          </h3>
          <p>{t("latestTracking")}</p>
        </section>
      </div>
    </main>
  );
};

export default AirTransportation;
